import { render, staticRenderFns } from "./zhuanti-chanyejingji.vue?vue&type=template&id=0b56baf2&"
import script from "./zhuanti-chanyejingji.vue?vue&type=script&lang=js&"
export * from "./zhuanti-chanyejingji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports